// extracted by mini-css-extract-plugin
export default {"debug":"Debug_debug__q+3+6","title":"Debug_title__acQqj","content":"Debug_content__kGvXG"};